import { render } from "./otherdeduction.vue?vue&type=template&id=a904f210"
import script from "./otherdeduction.vue?vue&type=script&lang=js"
export * from "./otherdeduction.vue?vue&type=script&lang=js"

import "./otherdeduction.vue?vue&type=style&index=0&id=a904f210&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__